export class CollateralSkillSet {
    public id: string;
    public name: string;
    public productSkillsetId: string;
}

export class ProductSkillSet {
    public name: string;
    public id: string;
}

export class AddSkillset {
    public name: string;
    public productSkillsetId: string;
}



// WEBPACK FOOTER //
// D:/a/1/s/Uhm.Loops.Web/src/app/collateralskillsets/collateralskillset.model.ts